
  (() => {
    const dialog = document.getElementById('AEArchiveDialog');
    const reopen = document.getElementById('AEArchiveReopen');
    if (!dialog || !reopen || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const read = (storage, key) => { try { return window[storage].getItem(key); } catch { return null; } };
    const write = (storage, key, value) => { try { window[storage].setItem(key, value); } catch {} };
    const remove = (storage, key) => { try { window[storage].removeItem(key); } catch {} };
    const pending = Number(read('sessionStorage', 'ae_archive_pending'));
    const recentSubmission = pending > Date.now() - 1800000;
    const success = Boolean(dialog.querySelector('[data-ae-success]'));
    const errors = Boolean(dialog.querySelector('[data-ae-error]'));
    const preview = new URLSearchParams(location.search).get('ae_signup_preview') === '1';
    let previousOverflow = '';
    let previousFocus;
    let hasOpened = false;
    const open = () => {
      if (dialog.open) return;
      hasOpened = true;
      previousFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      reopen.hidden = true;
      dialog.querySelector('[data-ae-close]').focus({preventScroll:true});
    };
    const close = () => dialog.close();
    dialog.querySelectorAll('[data-ae-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('click', event => {if(event.target === dialog){const r=dialog.getBoundingClientRect();if(event.clientX<r.left || event.clientX>r.right || event.clientY<r.top || event.clientY>r.bottom)close();}});
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      write('localStorage', 'ae_archive_dismissed', String(Date.now()));
      reopen.hidden = success || read('localStorage', 'ae_archive_joined') === '1';
      if(previousFocus instanceof HTMLElement) previousFocus.focus({preventScroll:true});
    });
    reopen.addEventListener('click',open);
    dialog.querySelector('form')?.addEventListener('submit',() => write('sessionStorage','ae_archive_pending',String(Date.now())));
    if(recentSubmission && (success || errors)){
      remove('sessionStorage','ae_archive_pending');
      if(success)write('localStorage','ae_archive_joined','1');
      open();return;
    }
    if(preview){open();return;}
    if(dialog.dataset.designMode === 'true' || dialog.dataset.subscriber === 'true' || read('localStorage','ae_archive_joined') === '1' || success)return;
    reopen.hidden = false;
    const dismissed = Number(read('localStorage','ae_archive_dismissed'));
    if(dismissed && Date.now()-dismissed < 14*86400000)return;
    let elapsed=false, scrolled=false;
    const eligible=()=>{
      if(hasOpened)return;
      const otherDialog=Array.from(document.querySelectorAll('dialog[open]')).some(d=>d!==dialog);
      if(elapsed && scrolled && !otherDialog && !document.hidden && !document.activeElement?.matches('input,textarea,select')){open();window.removeEventListener('scroll',onScroll);}
    };
    const onScroll=()=>{scrolled=window.scrollY>Math.min(220,Math.max(60,(document.documentElement.scrollHeight-innerHeight)*.2));eligible();};
    window.addEventListener('scroll',onScroll,{passive:true});
    window.setTimeout(()=>{elapsed=true;onScroll();},18000);
  })();
